import DatatableIntetrface from '@/utils/datatable/datatableInterface'
import Datatable  from '@/utils/datatable/datatable'
import { HeaderInterface } from '@/utils/datatable/header/headerInterface';
import TextHeader from '@/utils/datatable/header/textHeader';
import ImgHeader from '@/utils/datatable/header/imgHeader';
import ActionsHeader from '@/utils/datatable/header/actions/actionsHeader';
import filters from './filters'

const headers:HeaderInterface[] = [
  new TextHeader('NameAr'),
  new TextHeader('Title'),
  new ImgHeader('Image'), 
  new TextHeader('Skills'),
  new ActionsHeader('consultunts'  , {edit : true , view : true , delete : true})
]
const url = "/consultunts?type=team"

const params:DatatableIntetrface = {
    headers ,
    searchable:true,
    url,
    filters,
    hasFooter:false,
    hasEdit:true,
    title:"team",
    hasCreate:false
}
const datatable = new Datatable(params)
export default datatable
